import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitFoundingCustomer = (payload) =>
  api.post("/founding-customer", payload).then((r) => r.data);

export const submitDemoRequest = (payload) =>
  api.post("/demo-request", payload).then((r) => r.data);

export const subscribeNewsletter = (payload) =>
  api.post("/newsletter", payload).then((r) => r.data);

export const fetchFoundingSpots = () =>
  api.get("/founding-spots").then((r) => r.data);

export const confirmNewsletter = (token) =>
  api.get(`/newsletter/confirm`, { params: { token } }).then((r) => r.data);
